module.exports = __webpack_public_path__ + "gi.svg?a5f17d1abdd0f96e9b82206e2ae3d0f9";